/**
 * @module isOriginatorBlocked
 */

import hasClientConfiguration from './hasClientConfiguration';
import getClientConfigurationFromStore from '../selectors/getClientConfigurationFromStore';

/**
 * @function
 * A method to search for a given originator in the list of given provider configs
 * @param {Array} providerConfigs - An array of provider configs
 * @param {string} originator - Originator to search
 * @returns An originator is present or not
 */

const searchOriginator = (providerConfigs, originator): boolean => {
    let isFound = false;
    for (const config of providerConfigs) {
        if (config.originator === originator) {
            isFound = true;
            break;
        }
    }
    return isFound;
};

/**
 * @function
 * A method which checks whether the originator is blocked or not
 * @param {string} originator - Originator to be verified
 * @param {boolean} isDarkMode - Is a dark mode
 * @returns Whether an originator is blocked or not
 */

const isOriginatorBlocked = (originator: string, isDarkMode: boolean): boolean => {
    let isBlocked = false;
    if (hasClientConfiguration()) {
        const cache = getClientConfigurationFromStore();
        if (!isDarkMode && cache?.data?.providerConfigs) {
            isBlocked = searchOriginator(cache.data.providerConfigs, originator);
        } else if (isDarkMode && cache?.data?.providerConfigsDarkMode) {
            isBlocked = searchOriginator(cache.data.providerConfigsDarkMode, originator);
        }
    }
    return isBlocked;
};

export default isOriginatorBlocked;
